export default {
	"pages": {
		"root": {
			"id": "root",
			"pageUrl": "root",
			"name": "root",
			"children": [
				"68d287b3eb72ed0019e8ba42",
				"68d287b3eb72ed0019e8ba46"
			]
		},
		"68d287b3eb72ed0019e8ba42": {
			"id": "68d287b3eb72ed0019e8ba42",
			"name": "404",
			"pageUrl": "404"
		},
		"68d287b3eb72ed0019e8ba46": {
			"id": "68d287b3eb72ed0019e8ba46",
			"name": "index",
			"pageUrl": "index"
		}
	},
	"mode": "production",
	"projectType": "create-react-app",
	"site": {
		"styles": {
			"background": "--color-pageBg"
		},
		"seo": {
			"og:description": "Our talented team will not only document your wedding day, we will help you curate a day that is uniquely you.",
			"og:title": "Your wedding will be perfect",
			"favicon_32px": "https://uploads.quarkly.io/615c316435c5c8001f775568/images/openmoji_couple-with-heart32.png?v=2021-10-05T11:11:03.451Z",
			"favicon_apple_152px": "https://uploads.quarkly.io/615c316435c5c8001f775568/images/openmoji_couple-with-heart152.png?v=2021-10-05T11:11:13.507Z",
			"description": "Our talented team will not only document your wedding day, we will help you curate a day that is uniquely you.",
			"og:image": "https://uploads.quarkly.io/615c316435c5c8001f775568/images/wedding%20template.png?v=2021-10-05T11:13:30.358Z",
			"favicon_win10_270px": "https://uploads.quarkly.io/615c316435c5c8001f775568/images/openmoji_couple-with-heart270.png?v=2021-10-05T11:11:22.612Z",
			"background_win10": "#30251F",
			"title": "Your wedding will be perfect"
		}
	}
}